const themes = [
  { themeName: 'Default' },
  { themeName: 'Green' },
  { themeName: 'Blue' },
  { themeName: 'Orange' },
  { themeName: 'Red' },
  { themeName: 'VividOrange' },
  { themeName: 'LightBlue' }
];
export default themes;
